import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=010e27ca&scoped=true"
import script from "./ItemsTable.vue?vue&type=script&lang=js"
export * from "./ItemsTable.vue?vue&type=script&lang=js"
import style0 from "./ItemsTable.vue?vue&type=style&index=0&id=010e27ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e27ca",
  null
  
)

export default component.exports